import { Box, CircularProgress, IconButton, ThemeProvider, Tooltip, Typography } from "@mui/material";
import React from "react";
import MUIDataTable from "mui-datatables";
import LoadingOverlay from "react-loading-overlay-ts";
import Searchbox from "../Dashboard/Searchbox";
import { EmptyRowIcon } from "../Icons/EmptyRowIcon";

import { PrintButtonIcon, components } from "../Icons/DataTableIcons";
import FilterButton from "../Button/FilterButton";
import { MuiDataTableTheme } from "../MuiDataTableTheme/MuiDataTableTheme";




const DataTable = ({ tableName, data, columns, action, searchPlaceHolder, loading, serverSide, count, icon, changePage, page, searchText, expandableRows, loadPrint, filter, actionButtons, showNoDataMessage, onDownload, download, viewColumns, noOtherActions, onSearch, print, ...props }) => {
    const paginationOptions = {
        ...{ props },
        sort: false,
        filter: false,
        rowsPerPage: 10,
        rowsPerPageOptions: [],
        search: false,
        debounceSearchRender: 500,
        searchPlaceholder: `Search for ${searchPlaceHolder}` ?? "search",
        ...(searchText && { searchText: searchText }),
        print: false,
        download: download ?? true,
        viewColumns: viewColumns ?? true,
        serverSide: serverSide ?? true,
        count: count ?? 0,
        ...(page && { page: page }),
        jumpToPage: Boolean(true),
        responsive: "standard",
        expandableRows: false ?? expandableRows,
        disableRipple: true,
        elevation: 0,
        filterType: "dropdown",
        fixedHeader: true,
        tableBodyMinHeight: "600px",
        tableBodyMaxHeight: "1000px",
        selectableRows: "none",
        checkbox: false,
        onDownload: (buildHead, buildBody, columns, data) => {
            if (onDownload !== undefined) {
                onDownload()
            }
            return false;
        },
        textLabels: {
            body: {
                noMatch: showNoDataMessage ? <EmptyRowIcon /> : "",
                toolTip: "Sort",
                columnHeaderTooltip: (column) => `Sort for ${column.label}`,
            },
            pagination: {
                next: "Next Page",
                previous: "Previous Page",
                rowsPerPage: "Rows per page:",
                displayRows: "of",
            },
            toolbar: {
                search: "Search",
                downloadCsv: "Download sheet",
                print: "Print page",
                viewColumns: "View columns",
                filterTable: "Filter table",
            },
            filter: {
                all: "All",
                title: "FILTERS",
                reset: "RESET",
            },
            viewColumns: {
                title: "Show Columns",
                titleAria: "Show/Hide Table Columns",
            },
            selectedRows: {
                text: "row(s) selected",
                delete: "Delete",
                deleteAria: "Delete Selected Rows",
            },
        },
        customToolbar: () => {
            return (
                <>
                    {print && <Tooltip title="Print Table">
                        <IconButton onClick={() => alert("printed")}>
                            {loadPrint !== undefined && loadPrint ? <CircularProgress size={24} /> : <PrintButtonIcon />}
                        </IconButton>
                    </Tooltip>}

                    {filter?.options?.length > 0 && <FilterButton
                        options={filter?.options ?? []}
                        filters={filter?.filters ?? []}
                        onClick={filter?.handleFilterClick}
                        reset={filter?.handleReset}
                    />}

                    {actionButtons ?? ""}
                </>
            );
        },
        onTableChange: (action, tableState) => {
            if (action === "changePage") {
                changePage && changePage(tableState);
            }
        },
    };
    const displayData = [
        { status: true },
        { status: false },
        { status: true },
        { status: false },
    ];
    return (
        <ThemeProvider theme={MuiDataTableTheme}>
            <LoadingOverlay
                active={loading}
                styles={{
                    overlay: (base) => ({
                        ...base,
                        background: "rgba(0, 0, 0, 0.15)",
                    }),
                }}
                spinner
                text="Fetching Data for You..."
            >
                <MUIDataTable
                    title={
                        <Box
                            display="flex"
                            alignItems="center"
                            gap={10}
                            justifyContent="space-between"
                        >
                            <Typography
                                sx={{ color: "#05004E", fontWeight: 600 }}
                            >
                                {tableName ?? ""}
                            </Typography>
                            <Searchbox
                                placeholder={searchPlaceHolder ?? "search"}
                                onChange={onSearch}
                                value={searchText}
                            />
                        </Box>
                    }
                    data={data ?? []}
                    columns={columns ?? []}
                    options={paginationOptions}
                    components={components}
                    displayData={displayData}
                    style={{ transition: "0.7s" }}
                />
            </LoadingOverlay>
        </ThemeProvider>
    );
};

export default DataTable;
